function pastDueRowKey(row) {
  const leaseId = Number(row && row.leaseId);
  if (!Number.isFinite(leaseId)) return "";
  return String(leaseId);
}

function pastDueDefaultSelection(recipients) {
  return (recipients || []).map(pastDueRowKey).filter(Boolean);
}

function pastDueToggleSelection(selectedKeys, row) {
  const key = pastDueRowKey(row);
  const next = Array.isArray(selectedKeys) ? selectedKeys.slice() : [];
  const index = next.indexOf(key);
  if (index >= 0) next.splice(index, 1);
  else if (key) next.push(key);
  return next;
}

function pastDueSendBody(selectedRows) {
  return {
    confirm: true,
    recipients: (selectedRows || []).map((row) => ({
      leaseId: Number(row.leaseId),
    })),
  };
}

function pastDueConfirmState({ recipients, selectedKeys } = {}) {
  const rows = Array.isArray(recipients) ? recipients : [];
  if (!rows.length) {
    return {
      canSend: false,
      prompt: "No leases currently have an amount due.",
    };
  }
  const selected = new Set(selectedKeys || []);
  const chosen = rows.filter((row) => selected.has(pastDueRowKey(row)));
  if (!chosen.length) {
    return { canSend: false, prompt: "Select at least one lease." };
  }
  const already = chosen.filter((row) => row.alreadySent).length;
  const noun = chosen.length === 1 ? "lease" : "leases";
  let prompt = `Send a past due text to ${chosen.length} ${noun}?`;
  if (already > 0) {
    prompt += ` ${already} already received one this month.`;
  }
  return { canSend: true, prompt };
}

function pastDueRecipientLabel(row) {
  const name = String((row && row.name) || "").trim() || "Tenant";
  const place = String((row && row.address) || "").trim();
  const amount = String((row && row.amount) || "").trim();
  const who = place ? `${name} (${place})` : name;
  return amount ? `${who} — ${amount}` : who;
}

function pastDueRowNote(row) {
  if (row && row.alreadySent) return "Already sent";
  if (row && row.optInPending) return "Waiting for opt-in";
  if (row && row.needsOptIn) return "Opt-in first";
  return "";
}

function pastDueAmountLabel(amount) {
  if (amount == null || String(amount).trim() === "") return "";
  const n = Number(String(amount).replace(/[^0-9.-]/g, ""));
  if (!Number.isFinite(n)) return "";
  const cents = Math.round(Math.abs(n) * 100);
  const dollars = Math.floor(cents / 100);
  const rem = cents % 100;
  const withCommas = String(dollars).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  return `$-${withCommas}.${String(rem).padStart(2, "0")}`;
}

function pastDueAmountDue(row) {
  if (row && Number.isFinite(Number(row.balance))) {
    return Math.abs(Number(row.balance));
  }
  const n = Number(String((row && row.amount) || "").replace(/[^0-9.-]/g, ""));
  return Number.isFinite(n) ? Math.abs(n) : 0;
}

function pastDueSortByAmount(rows, direction) {
  const sign = direction === "asc" ? 1 : -1;
  return (rows || []).slice().sort((a, b) => {
    const diff = pastDueAmountDue(a) - pastDueAmountDue(b);
    if (diff) return diff * sign;
    return String((a && a.name) || "").localeCompare(String((b && b.name) || ""));
  });
}

function pastDueNextAmountSort(current) {
  return current === "desc" ? "asc" : "desc";
}

function pastDueSendResult({ sent, alreadySent, failed, queued } = {}) {
  const n = Number(sent) || 0;
  const skipped = Number(alreadySent) || 0;
  const bad = Number(failed) || 0;
  const held = Number(queued) || 0;
  const noun = n === 1 ? "text" : "texts";
  let message = `Sent ${n} past due ${noun}.`;
  if (held > 0) message += ` ${held} will get the opt-in text first.`;
  if (skipped > 0) message += ` ${skipped} already had one this month.`;
  if (bad > 0) message += ` ${bad} could not be sent.`;
  return message;
}

module.exports = {
  pastDueRowKey,
  pastDueDefaultSelection,
  pastDueToggleSelection,
  pastDueSendBody,
  pastDueConfirmState,
  pastDueRecipientLabel,
  pastDueRowNote,
  pastDueSendResult,
  pastDueSortByAmount,
  pastDueNextAmountSort,
  pastDueAmountLabel,
};
